import { render, staticRenderFns } from "./HistoryActiveClass.vue?vue&type=template&id=d655a8fc&scoped=true&"
import script from "./HistoryActiveClass.vue?vue&type=script&lang=js&"
export * from "./HistoryActiveClass.vue?vue&type=script&lang=js&"
import style0 from "./HistoryActiveClass.vue?vue&type=style&index=0&id=d655a8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d655a8fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
